function getNestedValue(obj: any, path: string) {
  if (!path) return "";
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

export const objUtility = { getNestedValue };
